// extracted by mini-css-extract-plugin
export default {"root":"MDTAirdrop_root__6AlNF","indent":"MDTAirdrop_indent__M3rXQ"};